(function($, undefined) {
	'use strict';
	
	var submitBtn;
	var labels;
	
	var submitSearchQuery = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-component');
		
		var serveItem = $('.recherche-region-dessert-input .form-checkbox-input:checked');
		var field16Item = $('.recherche-covid-input .form-checkbox-input:checked');
		var listInput = $('.recherche-component-list-input:checked', ctn);
		var inputCtn = listInput.closest('.recherche-component-list-item');
		var inputId = inputCtn.attr('data-id');
		var regionDropdownItems = $('.recherche-filtre-region', ctn);
		var aggloDropdownItems = $('.recherche-filtre-agglomeration', ctn);
		var villeDropdownItems = $('.recherche-filtre-ville', ctn);
		
		var newRegionValue = $('.dropdown-select-input', regionDropdownItems).val() === 'all' || $('.dropdown-select-input', regionDropdownItems).val() === undefined ? '' : $('.dropdown-select-input', regionDropdownItems).val();
		var newAggloValue = $('.dropdown-select-input', aggloDropdownItems).val() === 'all' || $('.dropdown-select-input', aggloDropdownItems).val() === undefined ? '' : $('.dropdown-select-input', aggloDropdownItems).val();
		var newVilleValue = $('.dropdown-select-input', villeDropdownItems).val() === 'all' || $('.dropdown-select-input', villeDropdownItems).val() === undefined ? '' : $('.dropdown-select-input', villeDropdownItems).val();
	
		var serveValue = (serveItem.length === 0) ? "" : serveItem.val();
		var field16Value = (field16Item.length === 0) ? "" : field16Item.val();
		var txValue = listInput.length === 0 ? '' : listInput.val();
		var field11Value = encodeURIComponent(newRegionValue);
		var field12Value = encodeURIComponent(newAggloValue);
		var field13Value = encodeURIComponent(newVilleValue);
		
		$('.recherche-component-note', ctn).removeClass('show');
		
		if (field13Value === '') {
			$('.recherche-component-error-message', ctn).slideDown(200);
		} else {
			$('.recherche-component-error-message', ctn).slideUp(200);
			
            saveSessionVariable('serve', serveValue, function () {
                saveSessionVariable('field11', field11Value, function () {
                    saveSessionVariable('field12', field12Value, function () {
                        saveSessionVariable('field13', field13Value, function () {
                            saveSessionVariable('field16', field16Value, function () {
                                //window.location.href = url;
                            });
                        });
                    });
                });
			});
			
			var query = '/action/getOrganizations?ajax=true=';
			query += '&distance=40000';
			query += '&maxResults=299792458';
			query += '&field11='+field11Value;
			query += '&field12='+field12Value;
			query += '&field13='+field13Value;
			query += '&field16='+field16Value;
			query += '&serve='+serveValue;
			query += '&lat=45.50867';
			query += '&lng=-73.553992';
			query += '&tx='+txValue;
			
			$.ajax({
				url: query,
				cache: false,
				success: function (data) {
//					console.log(data);
					$('.recherche-component-no-results-header', ctn).show();
					$('.recherche-component-no-results-header .red', ctn).html(data.length);
					
					if (data.length !== 0) {
						$('.recherche-component-no-results', ctn).hide();
						$('.recherche-component-results-ctn', ctn).show();
						$('.recherche-component-results-item:not(.clone)', ctn).remove();
						$('.recherche-component-note[data-id="'+inputId+'"]', ctn).addClass('show');
						
                        data.sort(function compare(a, b) {
                            if (a.name < b.name)
                                return -1;
                            else if (a.name > b.name)
                                return 1;
                            else
                                return 0;
                        });
						for(var i = 0;i < data.length;i++) {
							var phone = data[i].description.AllFields.Phone1Number === undefined ? '' : decodeText(data[i].description.AllFields.Phone1Number);
							var website = data[i].description.AllFields.WebsiteAddress === undefined ? '' : decodeText(data[i].description.AllFields.WebsiteAddress);
							var email = data[i].description.AllFields.EmailAddressMain === undefined ? '' : decodeText(data[i].description.AllFields.EmailAddressMain);
							var territory = data[i].description.AllFields.CoverageArea === undefined ? '' : decodeText(data[i].description.AllFields.CoverageArea);
							var clientele = data[i].description.AllFields.Eligibility === undefined ? '' : decodeText(data[i].description.AllFields.Eligibility);
							
							var hoursOfOperation = data[i].description.AllFields.HoursOfOperation === undefined ? '' : decodeText(data[i].description.AllFields.HoursOfOperation);
							//var eligibility = data[i].description.AllFields.Eligibility === undefined ? '' : decodeText(data[i].description.AllFields.Eligibility);
							var applicationProcess = data[i].description.AllFields.ApplicationProcess === undefined ? '' : decodeText(data[i].description.AllFields.ApplicationProcess);
							//var coverageArea = data[i].description.AllFields.CoverageArea === undefined ? '' : decodeText(data[i].description.AllFields.CoverageArea);
							var feeStructureSource = data[i].description.AllFields.FeeStructureSource === undefined ? '' : decodeText(data[i].description.AllFields.FeeStructureSource);
							
							var newElt = $('.recherche-component-results-item.clone', ctn).clone().removeClass('clone');
							$('.recherche-content-list-item-title', newElt).html(decodeText(data[i].name));
							$('.recherche-content-list-item-title', newElt).attr('href', $('.recherche-content-list-item-title', newElt).attr('href')+'/'+decodeText(data[i].friendlyUrl));
							$('.component-detail-btn', newElt).attr('href', $('.component-detail-btn', newElt).attr('href')+'/'+decodeText(data[i].friendlyUrl));
							
							
							if (hoursOfOperation !== '') {
								$('.recherche-content-list-item-info.hoursOfOperation .recherche-content-list-item-info-value', newElt).html(decodeText(hoursOfOperation));
							} else {
								$('.recherche-content-list-item-info.hoursOfOperation', newElt).remove();
							}
							/*if (eligibility !== '') {
								$('.recherche-content-list-item-info.eligibility .recherche-content-list-item-info-value', newElt).html(decodeText(eligibility));
							} else {
								$('.recherche-content-list-item-info.eligibility', newElt).remove();
							}*/
							if (applicationProcess !== '') {
								$('.recherche-content-list-item-info.applicationProcess .recherche-content-list-item-info-value', newElt).html(decodeText(applicationProcess));
							} else {
								$('.recherche-content-list-item-info.applicationProcess', newElt).remove();
							}
							/*if (coverageArea !== '') {
								$('.recherche-content-list-item-info.coverageArea .recherche-content-list-item-info-value', newElt).html(decodeText(coverageArea));
							} else {
								$('.recherche-content-list-item-info.coverageArea', newElt).remove();
							}*/
							if (feeStructureSource !== '') {
								$('.recherche-content-list-item-info.feeStructureSource .recherche-content-list-item-info-value', newElt).html(decodeText(feeStructureSource));
							} else {
								$('.recherche-content-list-item-info.feeStructureSource', newElt).remove();
							}
							
							if (phone !== '') {
								$('.organization-item-link.phone', newElt).attr('href', 'tel:'+phone);
								$('.organization-item-link.phone .organization-item-link-icon', newElt).attr('title', phone);
								$('.organization-item-link.phone .organization-item-link-title', newElt).html(phone);
							} else {
								$('.organization-item-link.phone', newElt).remove();
							}
							
							if (website !== '') {
                                var web = (website.indexOf("http://") !== -1) ? website : "http://"+website;
								$('.organization-item-link.website', newElt).attr('href', web);
								$('.organization-item-link.website', newElt).attr('target', "_blank");
								$('.organization-item-link.website .organization-item-link-icon', newElt).attr('title', web);
								$('.organization-item-link.website .organization-item-link-title', newElt).html(website);
							} else {
								$('.organization-item-link.website', newElt).remove();
							}
							
							if (email !== '') {
								$('.organization-item-link.email', newElt).attr('href', 'mailto:'+email);
								$('.organization-item-link.email .organization-item-link-icon', newElt).attr('title', email);
								$('.organization-item-link.email .organization-item-link-title', newElt).html(email);
							} else {
								$('.organization-item-link.email', newElt).remove();
							}
							
							if (territory !== '') {
								$('.organization-item-link.territory .organization-item-link-icon', newElt).attr('title', territory);
								$('.organization-item-link.territory .organization-item-link-title', newElt).html(territory);
							} else {
								$('.organization-item-link.territory', newElt).remove();
							}
							
							if (clientele !== '') {
								$('.organization-item-link.clientele .organization-item-link-icon', newElt).attr('title', clientele);
								$('.organization-item-link.clientele .organization-item-link-title', newElt).html(clientele);
							} else {
								$('.organization-item-link.clientele', newElt).remove();
							}
							
							$('.recherche-component-results-ctn', ctn).append(newElt);
						}
					} else {
						$('.recherche-component-results-ctn', ctn).hide();
						
						if (newRegionValue === 'Montréal' || newRegionValue === 'Montreal') {
							$('.recherche-component-no-results.montreal', ctn).show();
						} else {
							$('.recherche-component-no-results.default', ctn).show();
						}
					}
				}
			});
		}
	};
	
	var updateQueryStringParameter = function (uri, key, value) {
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	};
    
    var selectFocused = function(){
        var t = $(this);
        window.onkeyup = function (e) {
            var key = e.keyCode ? e.keyCode : e.which;

            if (key === 13) {
                t.find("input").attr("checked", true);
            } 
        };
    };
	
	var init = function () {
		submitBtn = $('.recherche-component .recherche-region-btn');
		submitBtn.click(submitSearchQuery);
        
        labels = $(".recherche-component-list-item label");
        labels.on("focus", selectFocused);
        
	};
	
	$(init);
})(jQuery);